import { createReducer } from 'services/reduxHelpers'
import { bookTypes } from 'reduxModules/actions/BookActions'

/* ------------- Initial State ------------- */

export const initialState = {
  savedBooking: [],
  departureTime: {},
  isLoading: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [bookTypes.ADD_BOOKING_ATTEMPT]: () => ({
    isLoading: true
  }),
  [bookTypes.ADD_BOOKING_SUCCESS]: () => ({
    isLoading: false
  }),
  [bookTypes.ADD_BOOKING_FAILURE]: () => ({
    isLoading: false
  }),

  [bookTypes.GET_DEPARTURE_TIME_SUCCESS]: (_, { data }) => ({
    departureTime: data
  }),

  [bookTypes.SAVE_BOOKING_ATTEMPT]: (_, { data }) => ({
    savedBooking: data
  }),

  [bookTypes.ADD_SAVED_BOOKING_SUCCESS]: () => ({
    savedBooking: [],
    isLoading: false
  }),
  [bookTypes.ADD_SAVED_BOOKING_FAILURE]: () => ({
    savedBooking: [],
    isLoading: false
  }),

  [bookTypes.CLEAR_DEPARTURE_TIME_ATTEMPT]: () => ({
    departureTime: {}
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/BookReducer.js